import { UploadCloud } from "lucide-react";
import { Button } from "../../components/ui/Button";
import { formatRelative } from "../../lib/format";
import type { Campaign } from "../../lib/types";
import { publishStateOf } from "./publishState";

type PublishPromptProps = {
	campaign: Campaign;
	publishing: boolean;
	onPublish: () => void;
};

export const PublishPrompt = ({ campaign, publishing, onPublish }: PublishPromptProps) => {
	const state = publishStateOf(campaign);
	if (state === "live") return null;

	return (
		<div className="flex flex-wrap items-center justify-between gap-4 rounded-md border border-alert-line bg-alert-soft px-4 py-3">
			<div className="space-y-0.5">
				<p className="text-sm font-medium text-alert">
					{state === "never" ? "Saved, but never published" : "Your changes are saved but not live"}
				</p>
				<p className="text-xs text-ink-muted">
					{state === "never"
						? "Nothing reaches the storefront until you publish. Shoppers cannot see this offer yet."
						: `Edited ${formatRelative(campaign.contentUpdatedAt)}. Shoppers still see the version published ${formatRelative(campaign.publishedAt)}.`}
				</p>
			</div>
			<Button onClick={onPublish} disabled={publishing}>
				<UploadCloud className="h-4 w-4" strokeWidth={2} />
				{publishing ? "Publishing…" : state === "never" ? "Publish" : "Publish changes"}
			</Button>
		</div>
	);
};
